// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1MFRW","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__TM1HO"};